/**
 * hook: useDateLang()
 *
 * Provide dateLang objects for ASG components that require it.
 */

import localeDE from 'date-fns/locale/de';
import localeEN from 'date-fns/locale/en-GB';
import localeES from 'date-fns/locale/es';
import localeFR from 'date-fns/locale/fr';
import localeIT from 'date-fns/locale/it';
import localePL from 'date-fns/locale/pl';

import getLang from 'Utils/getLang';

const locales = {
  de: localeDE,
  en: localeEN,
  es: localeES,
  fr: localeFR,
  it: localeIT,
  pl: localePL,
};

export default () => locales[getLang()] || localeDE;
